import $ from 'jquery';
import CPMeta from '../cp-meta';
import {PLAYLIST, RECOMMEND} from '../constants';

/**
 *
 * @param {string} cpType
 * @param {string} kakaoTVType
 * @param {string} dsid
 * @param {string} playlistId
 * @param {string} clipId
 * @returns {string}
 */
function getRequestClipId(cpType, kakaoTVType, dsid, playlistId, clipId) {
  const defaultId = '';
  switch (cpType) {
    case CPMeta.CPTypes.CP_TYPE_YOUTUBE:
      return dsid;
    case CPMeta.CPTypes.CP_TYPE_KAKAOTV:
      return (kakaoTVType === PLAYLIST) ? playlistId :
        (kakaoTVType === RECOMMEND) ? clipId :
          defaultId;
    default:
      return defaultId;
  }
}


/**
 *
 * 플레이어 하단에 표시될 관련 영상 데이터를 가져온다.
 *
 * @param cpType
 * @param dsid
 * @param kakaoTVType
 * @param clipId
 * @param kakaoTVPlaylistId
 * @returns {jQuery.Deferred}
 */
function fetchRelatedClips({cpType, dsid, kakaoTVType, clipId, kakaoTVPlaylistId}) {
  const id = getRequestClipId(cpType, kakaoTVType, dsid, kakaoTVPlaylistId, clipId);
  if (!id) {
    const d = $.Deferred();
    d.reject(new Error('clipId not found'));

    return d;
  }

  const params = {
    w: 'vclip',
    m: 'ft_proxy',
    viewtype: 'json',
    q: '',
    uuid: window.uuid,
    type: cpType,
    tvpot_type: kakaoTVType,
    clip_id: clipId,
    id
  };
  const qsearchURL = SF.getQsUrl(params, 1);
  return $.ajax({
    url: qsearchURL,
    dataType: 'json'
  }).then((res) => {
    try {
      return JSON.parse(res.RESULT.VCLIP_API_FT_PROXY.ROOT);
    } catch(e) {
      return {};
    }
  });
}

export default fetchRelatedClips;


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/api/fetch-related-clips.js
 **/